module.exports = __webpack_public_path__ + "e145d4f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_hero/gogobusiness/hero_image.jpg
// module id = 840
// module chunks = 0 1 2 3 4 5